"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkingHoursTemplateDate_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var WorkingHoursTemplateDate_Factory = /** @class */ (function () {
    function WorkingHoursTemplateDate_Factory() {
    }
    WorkingHoursTemplateDate_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Date: Date_Factory_1.Date_Factory.CreateIncoming(model.Date),
            LocationId: model.LocationId,
            ProviderId: model.ProviderId,
            RecordId: model.RecordId,
            WorkingHoursTemplateId: model.WorkingHoursTemplateId,
        };
        return result;
    };
    WorkingHoursTemplateDate_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Date: Date_Factory_1.Date_Factory.CreateOutgoing(model.Date),
            LocationId: model.LocationId,
            ProviderId: model.ProviderId,
            RecordId: model.RecordId,
            WorkingHoursTemplateId: model.WorkingHoursTemplateId,
        };
        return result;
    };
    return WorkingHoursTemplateDate_Factory;
}());
exports.WorkingHoursTemplateDate_Factory = WorkingHoursTemplateDate_Factory;
